import { useState, useEffect } from "react";
import {
  TextField,
  Box,
  Grid,
  Typography,
  Paper,
  useTheme,
  Button,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useNavigate, useParams } from "react-router-dom";
import { useCompany } from "../Provider";
import { useAuth } from "../../../services/auth";
import fields from "../fields";
import { useRequest } from "../../../services/request";
import { Image } from "@mui/icons-material";

function BoxInfo({ company = [] }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { uploadPhoto } = useCompany();
  const [URLImage, setURLImage] = useState(company?.logoUrl);
  const req = useRequest();
  const [timezones, setTimezones] = useState([]);
  const [plateRegularExpressions, setPlateRegularExpressions] = useState([]);

  let params = useParams();
  let { role } = useAuth();
  const id = params.id;

  useEffect(() => {
    const fetchTimezones = async () => {
      try {
        const res = await req("TimeZone/GetTimeZoneList/list");
        const list = Array.isArray(res) ? res : res?.data || [];
        setTimezones(
          list.map((tz) => ({ value: tz.id, label: tz.displayName })),
        );
      } catch (e) {
        console.error(e);
      }
    };
    fetchTimezones();
  }, [req]);

  useEffect(() => {
    const fetchPlateRegularExpressions = async () => {
      try {
        const res = await req("Resource/PlateRegularExpressions", null, {}, true);
        const list = res?.data || [];
        setPlateRegularExpressions(
          list.map((item) => ({
            value: item.value,
            label: item.title,
          })),
        );
      } catch (e) {
        console.error(e);
      }
    };
    fetchPlateRegularExpressions();
  }, [req]);

  const uploadImage = async (image, id) => {
    try {
      await uploadPhoto(image, id);
      setURLImage(URL.createObjectURL(image));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Paper
      elevation={0}
      sx={{
        p: theme.dimensions.padding,
        mt: theme.dimensions.mt,
        mb: theme.dimensions.mb,
        background: theme.color.PaperbgColor,
        width: "90%",
      }}>
      <Typography variant="Poster" component="h4" gutterBottom>
        Company Information
      </Typography>
      <Grid container>
        {fields(timezones, plateRegularExpressions).map((f, index) => {
          if (f.editOnly) return [];
          return (
            <Grid
              item
              xs={4}
              sm={4}
              md={4}
              mt={2}
              key={index}
              sx={{ fontSize: "14px" }}>
              <span style={{ color: theme.color.PaperlabelColor }}>
                {f.label} :{" "}
              </span>
<span>
                  {f.name === "timeZoneName" ||
                  f.name === "plateRegularExpression"
                    ? f.options?.find(
                        (option) => option.value === company?.[f?.name],
                      )?.label || company?.[f?.name]
                    : company?.[f?.name] && company?.[f?.name]}
                {f.name === "isActive" &&
                  (company?.isActive ? (
                    <span style={{ color: "#4AA785" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ fontSize: 10, mr: 0.2 }}
                      />
                      Active
                    </span>
                  ) : (
                    <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ fontSize: 10, mr: 0.2 }}
                      />
                      Inactive
                    </span>
                  ))}
                {f.name === "payOnline" &&
                  (company?.payOnline ? (
                    <span style={{ color: "#4AA785" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ fontSize: 10, mr: 0.2 }}
                      />
                      Active
                    </span>
                  ) : (
                    <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ fontSize: 10, mr: 0.2 }}
                      />
                      Inactive
                    </span>
                  ))}
              </span>
            </Grid>
          );
        })}
        <Grid item xs={4} md={4} mt={5} ml={1}></Grid>
        <Grid item xs={4} md={4} mt={5} ml={1} sx={{ fontSize: "14px", mt: 3 }}>
          <span style={{ color: theme.color.PaperlabelColor }}>
            Company Logo
          </span>
          <Box
            sx={{
              width: 250,
              height: 150,
              border: "1px dashed gray",
              borderRadius: 1,
              mt: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {!company.logoUrl && <Image fontSize="large" color="action" />}
            {company.logoUrl && (
              <div style={{ height: "150px", width: "150px" }}>
                {" "}
                <img
                  alt="company_img"
                  src={URLImage}
                  style={{ height: "100%", width: "100%" }}
                />{" "}
              </div>
            )}
          </Box>
          <TextField
            type="file"
            fullWidth
            readOnly={true}
            helperText="Company Logo : Accepts .svg, .gif, .jpg, and .png"
            sx={{
              mt: theme.dimensions.mt,
              mb: theme.dimensions.mb,
            }}
            onChange={(event) =>
              uploadImage(event.target.files[0], id)
            }></TextField>
        </Grid>
      </Grid>
      {role === "Admin" && (
        <Box sx={{ display: "flex", justifyContent: "end" }} mr={2}>
          <Button
            onClick={() => navigate("edit")}
            sx={{
              background: theme.color.blackBackground,
              color: "white",
              "&:hover": { background: `${theme.color.black}` },
            }}>
            Edit
          </Button>
        </Box>
      )}
    </Paper>
  );
}

export default BoxInfo;
